import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CloseScrollStrategy } from "@angular/cdk/overlay";
import {
  GENDER_OPTIONS,
  BOOL_OPTIONS,
  // STATE_OPTIONS,
  // TRACK_OPTIONS,
  SECTOR_OPTIONS,
  STATUS_OPTIONS,
  COUNTRY_OPTIONS,
} from "src/app/enums/registration_options";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { MatStepper } from "@angular/material/stepper";

@Component({
  selector: "app-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class FormComponent implements OnInit {
  brands = [
    { value: "Louis Vuitton", viewValue: "Louis Vuitton" },
    { value: "Gucci", viewValue: "Gucci" },
    { value: "Prada", viewValue: "Prada" },
    { value: "Chanel", viewValue: "Chanel" },
  ];
  submitted = false;
  hide = true;
  gender = GENDER_OPTIONS;
  status = STATUS_OPTIONS;
  country = COUNTRY_OPTIONS;
  // tracks = TRACK_OPTIONS;
  sector = SECTOR_OPTIONS;
  // states = STATE_OPTIONS;
  bool = BOOL_OPTIONS;
  title = "newMat";
  li: any;
  lis = [];
  isLinear = true;
  stat: any;
  det: any;
  isre: any;
  ctr: any;
  sta: any;
  cit: any;
  name: any;
  filled: any;
  auth: any;
  btnDisabled = false;
  btnText = "Submit";
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  basicFilled = new FormControl("", [Validators.required]);
  displayStyles = "none";

  @ViewChild("stepper") stepper: MatStepper;

  constructor(
    private _formBuilder: FormBuilder,
    private router: Router,
    private http: HttpClient
  ) {}
  filles: any;
  ngOnInit() {
    this.filled = localStorage.getItem("formFilled");
    this.auth = localStorage.getItem("authToken");
    // if (this.auth == null) {
    //   Swal.fire("Login first to access form");
    //   this.router.navigate(["/login"]);
    // } else {
    //   if (this.filled == "true") {
    //     //isfilled
    //     this.router.navigate(["/db"]);
    //   }
    //   // else {
    //   //   this.router.navigate(["/form"]);
    //   // }
    // }
    this.firstFormGroup = this._formBuilder.group({
      name: ["", Validators.required],
      email: ["", Validators.compose([Validators.required, Validators.email])],
      country: [""],
      // city: [""],
      // state: [""],
      contact: [
        "",
        Validators.compose([Validators.required, Validators.min(10)]),
      ],
      gender: ["", Validators.required],
      // status: ["", Validators.required],
    });
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .get(environment.API_URL + "getMemb/", { headers })
      .subscribe((Response) => {
        this.li = Response;
        this.lis = this.li.all_memb;
      });
    this.name = localStorage.getItem("name");
    // this.stat = localStorage.getItem("profState");
    this.det = localStorage.getItem("wDet");
    this.filled = localStorage.getItem("formFilled");
    this.thirdFormGroup = this._formBuilder.group({
      // amount: ['', Validators.required],
      // stock: ['', Validators.required]
    });

    this.fourthFormGroup = this._formBuilder.group({
      startup: ["", Validators.required],
      sector1: ["", Validators.required],
      sector2: ["", Validators.required],
      idea: ["", Validators.required],

      // registered: ["", Validators.required],
      // track: ["", Validators.required],
    });
  }

  next1() {
    // this.displayStyles="block";
    if (this.secondFormGroup.invalid) {
      return;
      this.displayStyles = "none";
    }
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    // body.append("profStat", this.secondFormGroup.value.status);
    // body.append("city", this.secondFormGroup.value.city);
    // body.append("state", this.secondFormGroup.value.state);
    this.http
      .post<any>(environment.API_URL + "subReg/", body, { headers })
      .subscribe((data) => {
        this.displayStyles = "none";
      });
    this.displayStyles = "none";
  }

  nexts2(event: any) {
    this.btnDisabled = true;
    this.btnText = "Adding...";
    if (this.firstFormGroup.valid) {
      this.displayStyles = "block";
      const headers = {
        Authorization: "Token " + localStorage.getItem("authToken"),
      };
      var body: any = new FormData();
      body.append("name", this.firstFormGroup.value.name);
      body.append("email", this.firstFormGroup.value.email);
      body.append('ctry', 'ind');
      // body.append("state", this.firstFormGroup.value.state);
      // body.append("city", this.firstFormGroup.value.city);
      body.append("contact", this.firstFormGroup.value.contact);
      body.append("gender", this.firstFormGroup.value.gender);
      // body.append("profStat", this.firstFormGroup.value.status);
      this.http
        .post<any>(environment.API_URL + "addMemb/", body, { headers })
        .subscribe(
          (data) => {
            Swal.fire(data.status);
            this.displayStyle2 = "none";
            const headers = {
              Authorization: "Token " + localStorage.getItem("authToken"),
            };
            this.http
              .get(environment.API_URL + "getMemb/", { headers })
              .subscribe((Response) => {
                this.li = Response;
                this.lis = this.li.all_memb;
              });
            setTimeout(() => {
              console.log("Waiting");
            }, 5000);
            this.displayStyles = "none";
          },
          (error) => {
            console.log(error);
            setTimeout(() => {
              console.log("Waiting");
            }, 5000);
            this.displayStyles = "none";
          }
        );
    } else {
      // Swal.fire("Fill all the details correctly");
      Swal.fire("add member test error");

    }
    this.btnDisabled = false;
    this.btnText = "Submit";
  }

  // toggleLoaderDisplay(event: boolean) {
  //   if (event) {
  //     this.displayStyles = "block";
  //   } else {
  //     this.displayStyles = "none";
  //   }
  // }

  submitQuestionnaire() {
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    body.append("status", "True");
    this.http
      .post<any>(environment.API_URL + "formFilled/", body, {
        headers,
      })
      .subscribe((data) => {
        localStorage.setItem("formFilled", "true");
        this.displayStyles = "none";
      });
    this.router.navigateByUrl("/db");
  }

  async submit() {
    this.displayStyles = "block";
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    if (this.fourthFormGroup.valid) {
      const SwalConfirmation = await Swal.fire({
        title: "Before moving forward,",
        text: "Please make sure you have filled all the previous details correctly, as you won't be able to edit them once you move on to the questionniare.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Go back",
        reverseButtons: true,
      });

      if (!SwalConfirmation.isConfirmed) {
        this.displayStyles = "none";
        return;
      }

      var body: any = new FormData();
      body.append("name", this.fourthFormGroup.value.startup);
      body.append("desc", this.fourthFormGroup.value.idea);
      body.append("secA", this.fourthFormGroup.value.sector1);
      body.append("secB", this.fourthFormGroup.value.sector2);
      // body.append("isReg", this.fourthFormGroup.value.registered);
      // body.append("track", this.fourthFormGroup.value.track);

      this.http
        .post<any>(environment.API_URL + "addIdea/", body, { headers })
        .subscribe(
          (data) => {
            // Swal.fire("Idea Added Succesfully!");
            this.displayStyles = "none";
            this.basicFilled.setValue("done");

            // Move the Mat Stepper to the next step
            localStorage.setItem("tempid", data.idea.id);
            localStorage.setItem("preltrack", "");
            localStorage.setItem("prelname", data.idea.name);
            this.stepper.selectedIndex = 3;
          },
          (error) => {
            Swal.fire("An error ocurred please contact bhavesh@ecell.in");
            this.displayStyles = "none";
          }
        );

      this.submitted = true;
      // var body: any = new FormData();
      // body.append("status", "True");
      // this.http
      //   .post<any>(environment.API_URL + "formFilled/", body, {
      //     headers,
      //   })
      //   .subscribe((data) => {
      //     localStorage.setItem("formFilled", "true");
      //     this.displayStyles = "none";
      //   });
      // this.router.navigateByUrl("/db");
    } else {
      // const headers = { Authorization: "Token " + localStorage.getItem("authToken") }
      // this.submitted = true;
      // var body: any = new FormData();
      // body.append('status', 'True');
      // this.http.post<any>(environment.API_URL + "formFilled/", body, { headers }).subscribe(
      //   data => {
      //     localStorage.setItem("formFilled", 'true');
      //   },

      //   )
      this.displayStyles = "none";
      Swal.fire("Fill all the details correctly1");
    }
  }
  skip() {
    this.displayStyles = "block";
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.submitted = true;
    var body: any = new FormData();
    body.append("status", "True");
    this.http
      .post<any>(environment.API_URL + "formFilled/", body, {
        headers,
      })
      .subscribe((data) => {
        localStorage.setItem("formFilled", "true");
        this.displayStyles = "none";
      });
    this.displayStyles = "none";
    this.router.navigateByUrl("/db");
  }
  displayStyle2 = "none";

  openPopup2() {
    this.displayStyle2 = "block";
  }
  closePopup2() {
    this.displayStyle2 = "none";
  }

  submit2() {
    this.displayStyles = "block";
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .get(environment.API_URL + "getMemb/", { headers })
      .subscribe((Response) => {
        // console.log(Response)
        this.li = Response;
        this.lis = this.li.all_memb;
        // console.log(this.lis)
      });
    if (
      this.firstFormGroup.value.name.length != 0 &&
      this.firstFormGroup.value.email.length != 0
    ) {
      const headers = {
        Authorization: "Token " + localStorage.getItem("authToken"),
      };
      var body: any = new FormData();
      body.append("name", this.firstFormGroup.value.name);
      body.append("email", this.firstFormGroup.value.email);
      // body.append('ctry', this.firstFormGroup.value.country);
      // body.append("state", this.firstFormGroup.value.state);
      // body.append("city", this.firstFormGroup.value.city);
      body.append("contact", this.firstFormGroup.value.contact);
      body.append("gender", this.firstFormGroup.value.gender);
      // body.append("profStat", this.firstFormGroup.value.status);
      // body.append('wDet', this.firstFormGroup.value.institute);
      this.http
        .post<any>(environment.API_URL + "addMemb/", body, { headers })
        .subscribe(
          (data) => {
            // console.log("done")
            this.displayStyle2 = "none";
            this.displayStyles = "none";
            window.location.reload();
          },
          (error) => {
            //Error callback
            // console.error('error caught in component')
            // this.errorMessage = error;
            // this.loading = false;
            this.displayStyles = "none";

            Swal.fire("EmailID already Registered");
          }
        );
    } else {
      this.displayStyles = "none";

      Swal.fire("Fill all the details");
    }
  }
}
